import { Pipe, PipeTransform } from '@angular/core';
import { isNil, Nillable } from '@web/utils';

@Pipe({
  name: 'negate',
  standalone: true,
})
export class NegatePipe implements PipeTransform {
  public transform(logic: Nillable<boolean>): Nillable<boolean> {
    if (isNil(logic)) {
      return logic;
    }

    return !logic;
  }
}
